export default {
  label: '产品工程师',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '技术与产品的桥梁，侧重技术实现。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '负责产品的技术研发和实现，确保产品功能符合需求。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备一定的技术背景，能够理解产品需求并转化为技术解决方案。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在3-5年后晋升为产品经理。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪在8,000-20,000元之间，年薪约为25-50万元。',
          id: '0-5-1',
        },
      ],
    },
  ],
};